export const cart = {
  cartItems: {
    header: {
      article: 'Article',
      quantity: 'Quantity:',
      price: 'Price',
    },
    action: {
      addToWishlist: 'Add to wishlist',
      removeFromCart: 'remove from cart',
    },
    id: 'ID',
    description: 'Description',
    item: 'Item',
    itemPrice: 'Item price',
    quantity: 'Qty',
    quantityTitle: 'The quantity represents the total number of this item in your cart.',
    total: 'Total',
    cartTotal: 'Cart total ({{count}} item)',
    cartTotal_plural: 'Cart total ({{count}} items)',
    selection: 'Selection',
    showSelection: 'Show selection',
    hideSelection: 'Hide selection',
    articleNr: 'Article number:',
    soldOut: 'Sold out',
    notifyMe: 'Notify me',
    message: {
      itemAddedToCart: 'Your item has been added to the shopping cart',
      itemCannotAddToCart: 'Item cannot be added to the shopping cart',
      notEnoughInStock:
        'Unfortunately, there are only {{ stock }} pieces of this product available at the moment.',
    },
    removeItem: 'Remove',
    addToWishlist: 'Add to Wishlist',
    quantityShort: 'Quantity',
    removeFromWishlist: 'Remove from Wishlist',
    cartTotalSingle: 'Cart Total',
    unitPrice: 'Unit Price',
  },
  orderCost: {
    orderSummary: 'Order Summary',
    subtotal: 'Subtotal after discounts:',
    shipping: 'Shipping:',
    estimatedShipping: 'Estimated shipping:',
    discount: 'You saved:',
    salesTax: 'Sales Tax:',
    grossTax: 'The order total does not include tax of',
    grossIncludeTax: 'The order total includes tax of',
    total: 'Total:',
    toBeDetermined: 'TBD',
  },
  voucher: {
    coupon: 'Have a coupon?',
    couponGiftcard: 'Do you have a giftcard or coupon voucher code?',
    coupon_plural: 'Coupon codes',
    apply: 'Apply',
    placeholder: 'Promo code',
    applyVoucherSuccess: '{{voucherCode}} has been applied.',
    applyGiftardSuccess: 'The voucher {{voucherCode}} has been added to the cart.',
    removeVoucherSuccess: '{{voucherCode}} has been removed.',
    anchorLabel: 'Enter or remove your coupon code',
    vouchersApplied: 'Applied coupons',
    availableCoupons: 'Available coupons',
    availableCouponsLabel: 'You can add these coupons to this order.',
    promotionError: {
      ERR01: 'The promotion has already ended.',
      ERR02: 'The discount code is not yet valid.',
      ERR03: 'The discount code is not valid.',
      ERR05:
        'Your shopping cart does not contain any products to which the promotion can be applied.',
      ERR06: 'The discount code has already been redeemed.',
      ERR07: 'The minimum order value for the promotion has not been reached.',
      ERR08: 'The discount code is not valid.',
      ERR09: 'The coupon code that gives you the best price advantage has been applied.',
      ERR10: 'Shipping is free of charge, so the code you entered cannot be added.',
      ERR12: 'The voucher has already been redeemed.',
      ERR13:
        'Unfortunately, discount codes cannot currently be redeemed due to technical reasons. Please contact our customer service.',
      ERR14: 'The discount code cannot be applied to your cart.',
      ERR14WithDisclaimer:
        'The discount code cannot be applied to your cart. Please note the promotion conditions:<br>[Promotion code: {{voucherCode}}<br><br>{{disclaimer}}]',
    },
  },
  saveForLaterItems: {
    itemTotal: 'Saved for later ({{count}} item)',
    itemTotal_plural: 'Saved for later ({{count}} items)',
    cartTitle: 'Cart',
    saveForLater: 'Save For Later',
    moveToCart: 'Move To Cart',
    stock: 'Stock',
    forceInStock: 'In Stock',
  },
  slowRequestModal: {
    title: 'The total amount is being calculated',
    message: 'Please be patient for a moment.',
    thanks: 'Thank you for your understanding!',
    closeBtn: 'Cancel calculation',
  },
};
